"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MONTHLY_EMAIL = exports.WEEKLY_EMAIL = exports.DAILY_EMAIL = exports.INSTANT_EMAIL = exports.EMAIL_BLOG_TYPE = exports.SUBSCRIPTION_BLOG_ID = exports.REPLY_TO = exports.PORTAL_ID = exports.ID = exports.FROM_NAME = exports.ENABLED = exports.BLOG_EMAIL_TYPE_LABEL = exports.BLOG_EMAIL_TYPE = exports.BLOG_NOTIFICATION_EMAIL = void 0;
var BLOG_NOTIFICATION_EMAIL = 'BlogNotificationEmail';
exports.BLOG_NOTIFICATION_EMAIL = BLOG_NOTIFICATION_EMAIL;
var BLOG_EMAIL_TYPE = 'blog_email_type';
exports.BLOG_EMAIL_TYPE = BLOG_EMAIL_TYPE;
var BLOG_EMAIL_TYPE_LABEL = 'blog_email_type_label';
exports.BLOG_EMAIL_TYPE_LABEL = BLOG_EMAIL_TYPE_LABEL;
var ENABLED = 'enabled';
exports.ENABLED = ENABLED;
var FROM_NAME = 'from_name';
exports.FROM_NAME = FROM_NAME;
var ID = 'id';
exports.ID = ID;
var PORTAL_ID = 'portal_id';
exports.PORTAL_ID = PORTAL_ID;
var REPLY_TO = 'reply_to';
exports.REPLY_TO = REPLY_TO;
var SUBSCRIPTION_BLOG_ID = 'subscription_blog_id';
exports.SUBSCRIPTION_BLOG_ID = SUBSCRIPTION_BLOG_ID;
var EMAIL_BLOG_TYPE = 'BLOG_RSS';
exports.EMAIL_BLOG_TYPE = EMAIL_BLOG_TYPE;
var INSTANT_EMAIL = 'instant';
exports.INSTANT_EMAIL = INSTANT_EMAIL;
var DAILY_EMAIL = 'daily';
exports.DAILY_EMAIL = DAILY_EMAIL;
var WEEKLY_EMAIL = 'weekly';
exports.WEEKLY_EMAIL = WEEKLY_EMAIL;
var MONTHLY_EMAIL = 'monthly';
exports.MONTHLY_EMAIL = MONTHLY_EMAIL;